var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import teamService from "@irati/identity/services/teams";
import { Input } from "@irati/ui/src/FormItem";
import Loading from "@irati/ui/src/Loading";
import { H3 } from "@irati/ui/src/Headings";
import { Para } from "@irati/ui/src/Labels";
import Form from "@irati/ui/src/Form";
import CloseIcon from "@irati/ui/src/Close";
import { FormattedMessage } from "@irati/utils/lang";
import authentication from "@irati/auth";
import { Button } from "../styled";
var CreateTeamForm = /** @class */ (function (_super) {
    __extends(CreateTeamForm, _super);
    function CreateTeamForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            teamName: ""
        };
        _this.handleChange = function (teamName) {
            _this.setState({ teamName: teamName });
        };
        _this.handleSubmit = function () {
            var creatingTeam = teamService
                .create({ tenantId: authentication.business().uuid, data: { public_name: _this.state.teamName.trim() } })
                .then(function () { return _this.props.onSuccess(); });
            _this.setState({ creatingTeam: creatingTeam });
        };
        return _this;
    }
    CreateTeamForm.prototype.render = function () {
        var _a = this.state, teamName = _a.teamName, creatingTeam = _a.creatingTeam;
        return (React.createElement(Loading, { load: creatingTeam },
            React.createElement("div", { style: { position: "relative" } },
                React.createElement(H3, null,
                    React.createElement(FormattedMessage, { id: "setup_tenant.steps.teams.createTeamForm.title" })),
                React.createElement(Para, { margin: "15px 0 30px" },
                    React.createElement(FormattedMessage, { id: "setup_tenant.steps.teams.createTeamForm.description" })),
                React.createElement(Form, null,
                    React.createElement(Input, { name: "teamName", label: "Team name", placeholder: "e.g. Marketing", value: teamName, onChange: this.handleChange }),
                    React.createElement(Button, { primary: true, onClick: this.handleSubmit, margin: "15px 0" },
                        React.createElement(FormattedMessage, { id: "setup_tenant.steps.teams.createTeamForm.addTeamButton" }))),
                React.createElement(CloseIcon, { onClick: this.props.onCancel }))));
    };
    return CreateTeamForm;
}(Component));
export default CreateTeamForm;
